import {
  convertIntelligemsPriceToMinorUnits,
  ensureIntelligemsAvailability,
  parseIntelligemsPrice,
} from './intelligemsUtils';
import { IntelligemsData } from '../types/Intelligems';
import { logInfo } from '../utils/logging';

export function getIntelligemsMinProductPrice<T extends IntelligemsData>(
  productId: number | string | undefined,
  appsInfo: T,
): number | undefined {
  if (!appsInfo.is_intelligems_enabled || !productId) {
    return undefined;
  }

  if (!ensureIntelligemsAvailability()) {
    logInfo(
      'getIntelligemsMinProductPrice: intelligems not actually available after verification',
    );
    return undefined;
  }

  const rawPrice = window.igData?.price?.getMinPriceByProductId?.(productId);

  const price = parseIntelligemsPrice(
    rawPrice,
    `getIntelligemsMinProductPrice: productId ${productId}`,
  );

  const finalPrice = convertIntelligemsPriceToMinorUnits(price);

  logInfo(
    `getIntelligemsMinProductPrice: productId=${productId}, rawPrice=${rawPrice}, parsedPrice=${price}, finalPrice=${finalPrice}, finalPriceInDollars=${
      finalPrice ? finalPrice / 100 : 'undefined'
    }, hasIgData=${!!window.igData}, hasPriceObject=${!!window.igData
      ?.price}, hasGetMinPriceMethod=${!!window.igData?.price
      ?.getMinPriceByProductId}`,
  );

  // ensure we either return a valid number or undefined
  return Number.isFinite(finalPrice) ? finalPrice : undefined;
}
